import Vue from "vue";
import VueRouter from "vue-router";
import PageNotFound from "@/views/PageNotFound.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/lineup",
    name: "Lineup",
    component: () => import("@/views/LineupPage.vue"),
    meta: {
      title: "Interactive ACL Merch Lineup 2021 - Driphound",
    },
  },
  {
    path: "/about",
    name: "About",
    component: () => import("@/views/About.vue"),
    meta: {
      title: "About | Driphound Interactive ACL Merch Lineup 2021",
    },
  },
  {
    path: "/",
    name: "LandingPage",
    component: () => import("@/views/LandingPage.vue"),
  },
  {
    path: "/feed",
    name: "Feed",
    component: () => import("@/views/Feed.vue"),
  },
  {
    path: "/shop/:shopId",
    name: "Shop",
    component: () => import("@/views/ShopPage.vue"),
    props: true,
  },
  {
    path: "/list/:listId",
    name: "List",
    component: () => import("@/views/ListPage.vue"),
    props: true,
  },
  {
    path: "/likes",
    name: "Likes",
    component: () => import("@/views/MyLikes.vue"),
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: () => import("../views/NotificationsPage.vue"),
  },
  {
    path: "/search/:query?",
    name: "Search",
    component: () => import("@/views/Search.vue"),
    props: true,
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("@/views/Profile.vue"),
  },
  {
    path: "/product/:productId",
    name: "Details",
    component: () => import("../views/ProductDetails.vue"),
    props: true,
  },
  {
    path: "/settings",
    name: "Settings",
    component: () => import("@/views/Settings.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/LoginPage.vue"),
    meta: {
      guestsOnly: true,
    },
  },
  {
    path: "/signup",
    name: "Signup",
    component: () => import("@/views/SignupPage.vue"),
    meta: {
      guestsOnly: true,
    },
  },
  {
    path: "/:catchAll(.*)",
    component: PageNotFound,
    name: "PageNotFound",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // console.log("from", from);
    // console.log("to", to);
    // console.log("pos", savedPosition);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (to.name === "List" && savedPosition) {
          resolve(savedPosition);
        }
        if (to.name === "Feed" && savedPosition) {
          resolve(savedPosition);
        }
        return resolve({ left: 0, top: 0 });
      }, 0);
    });
  },
});

export default router;
